<script>
import { mapGetters } from 'vuex';
import MapEmbed from '@/components/MapEmbed.vue';
import FormContact from '@/components/FormContact.vue';
// import SnackbarContactForm from '@/components/SnackbarContactForm.vue';
import ModalFormFeedback from '@/components/ModalFormFeedback.vue';

export default {
  name: 'PageContact',
  components: {
    MapEmbed,
    FormContact,
    // SnackbarContactForm,
    ModalFormFeedback,
  },
  data() {
    return {
      isFeedbackVisible: false,
      status: false,
      feedbackMessage: '',
    };
  },
  computed: {
    ...mapGetters(['GET_SHEET_RESPONSE']),
  },
  watch: {
    GET_SHEET_RESPONSE(val) {
      // is triggered whenever the store state changes
      this.isFeedbackVisible = true;
      if (val.status === 'success') {
        this.status = true;
        this.feedbackMessage = this.$t('pageContact.form.feedbackSuccess');
      } else {
        this.feedbackMessage = this.$t('pageContact.form.feedbackFail');
        this.status = false;
      }
    },
  },
  methods: {},
};
</script>

<template>
  <main class="contact">
    <header>
      <h2 class="heading-2">{{ $t('pageContact.title') }}</h2>
      <h3 class="heading-3">{{ $t('pageContact.subtitle') }}</h3>
    </header>

    <section class="section" id="section">
      <div class="info">
        <article class="info__card">
          <img
            class="info__img"
            src="../assets/icons/ico-round-location.svg"
            alt="location"
          />
          <address>
            <p class="info__address">{{ $t('pageContact.address') }}</p>
            <p class="info__address">{{ $t('pageContact.village') }}</p>
            <p class="info__address">63078, {{ $t('pageContact.country') }}</p>
          </address>
        </article>
        <article class="info__card">
          <img
            class="info__img"
            src="../assets/icons/ico-round-mail.svg"
            alt="mail"
          />

          <a href="mailto:evkamba@gmail.com" class="info__text"
            >evkamba@gmail.com</a
          >
        </article>
        <article class="info__card">
          <img
            class="info__img"
            src="../assets/icons/ico-round-phone.svg"
            alt="mail"
          />

          <a href="tel:6948236910" class="info__text">6948236910</a>
        </article>
      </div>
      <form-contact></form-contact>
    </section>
    <map-embed class="map"></map-embed>
    <!-- <transition name="toggle-modal">
      <SnackbarContactForm :fail="sendfail" />
    </transition> -->
    <transition name="toggle-modal">
      <modal-form-feedback
        v-if="isFeedbackVisible"
        :success="status"
        @close-feedback="isFeedbackVisible = false"
      >
        <template #message>{{ feedbackMessage }}</template>
      </modal-form-feedback>
    </transition>
  </main>
</template>

<style scoped lang="scss">
.toggle-modal-enter-active,
.toggle-modal-leave-active {
  transition: all 0.3s ease;
}

.toggle-modal-enter,
.toggle-modal-leave-to {
  transform: translateY(50%);
  opacity: 0;
}
.contact {
  margin: auto;
}

header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--size-3-2);
  padding: var(--size-8-6) 0px;
  background-color: hsl(var(--clr-primary-500));
}

.section {
  min-width: 100%;
  padding: var(--size-8-6) var(--size-11-2);
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: var(--size-8-6);
  }
}

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--size-8-6);

  @media (max-width: 900px) {
    order: 2;
  }
}

.info__card {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--size-6-4);
}

.info__img {
  max-width: var(--size-9-7);
  height: auto;
}

.info__address {
  font-size: var(--fs-5-3);
  font-style: normal;
  line-height: 1.4;
  color: hsl(var(--clr-accent-100));
}
.info__text {
  font-size: var(--fs-5-3);
  color: hsl(var(--clr-accent-100));
}
</style>
